import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import authReducer from "./authReducer";
import postReducer from "./postReducer";
import profileReducer from "./profileReducer";
import themeReducer from "./themeReducer";

export default combineReducers({
  errors: errorReducer,
  auth: authReducer,
  post: postReducer,
  profile: profileReducer,
  darkMode: themeReducer,
});
